export default __webpack_public_path__ + "static/media/Walk (8).292825b5.png";